import routes from 'constants/routes';

/** URL del asistente nueva orden desde cotización, con la cotización precargada. */
export const buildNewOrderFromQuotationUrl = (quotationId: number): string =>
	`${routes.salesOrder.newFromQuotation}?quotationId=${quotationId}`;
